<script>
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {createEventDispatcher} from 'svelte/internal';
    import AppIcon from "../components/icons/AppIcon.svelte";

    export let account = null;

    const dispatch = createEventDispatcher();

    const onCreate = () => {
        dispatch('create');
    }

    const onEdit = (hotel) => {
        dispatch('edit', hotel.id);
    }

    const onDelete = (obj) => {
        Alert.delete("Delete hotel", `This will permanently delete hotel "${obj.name}".\nAre you sure?`, () => deleteHotel(obj.id));
    }

    const deleteHotel = (id) => {
        const onSuccess = result => {
            account.hotels = account.hotels.filter(x => x.id !== result);
            Notifier.showMessage("Hotel deleted");
        }

        const onFailure = err => {
        };

        R.handle(R.hotel.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }
</script>

<div class="panel panel-default mb-5">
    <div class="panel-heading py-2">
        Hotels
        <button class="btn btn-primary btn-sm" on:click="{ onCreate }" disabled="{ account.id == 0 }">CREATE HOTEL
        </button>
    </div>
    {#if account.id > 0}
        {#if account.hotels.length}
            <table class="table table-list">
                <tbody>
                {#each account.hotels as item}
                    <tr class="row-hover">
                        <td>
                            <span class="is-link" class:not-active={ item.is_active < 1 }
                                  on:click="{ () => onEdit(item) }">
                                { item.name }
                            </span>
                        </td>
                        <td class="button-column pointer" title="delete hotel" on:click="{ () => onDelete(item) }">
                            <AppIcon icon="trash" size="16"/>
                        </td>
                    </tr>
                {/each}
                </tbody>
            </table>
        {:else}
            <div class="panel-body panel-pad">
                Account has no hotels yet.
            </div>
        {/if}
    {:else}
        <div class="panel-body panel-pad">
            Save new account in order to add hotels
        </div>
    {/if}
</div>